import { InstrumentType } from '@zero/shared/util-models';
import { FamousIndication } from './shared-constants';

export const commonRoutes = {
  prelogin: {
    onboarding: {
      signUp: '/depot-eroeffnen/registrieren',
      enterPass: '/depot-eroeffnen/passwort-eingeben',
      emailConfirmation: '/depot-eroeffnen/email-bestaetigen',
      loginAfterEmailConfirmation: '/depot-eroeffnen/einloggen',
      resendConfirmationMail: '/depot-eroeffnen/registrieren/erneutbestaetigen',
    },
    home: '',
    forgot_pwd: '/login/passwortvergessen',
    emailregistration: '/login/registrierungsbestaetigung',
    register: '/depot-eroeffnen',
    preview: '/depot-eroeffnen/preview',
    resend_confirmation_mail: '/depot-eroeffnen/registrieren/erneutbestaetigen',
    tradeableproducts: '/handelbare-produkte',
    leverageProducts: '/hebelprodukte',
  },
  postlogin: {
    onboarding: {
      redirect: '/depot-eroeffnen/weiterleitung',
      mobileNumber: '/depot-eroeffnen/mobilfunknummer',
      person: '/depot-eroeffnen/person',
      residence: '/depot-eroeffnen/wohnsitz',
      nationality: '/depot-eroeffnen/staatsangehoerigkeit',
      bankAccount: '/depot-eroeffnen/referenzkonto',
      initialDeposit: '/depot-eroeffnen/ersteinzahlung',
      provision: '/depot-eroeffnen/gebuehrenfreier-handel',
      ident: '/depot-eroeffnen/identifikation',
      inProgress: '/depot-eroeffnen/in-bearbeitung',
      savingsPlan: {
        favoriteSuggestions: '/depot-eroeffnen/sparplan-anlegen/vorschlag',
        top3Issuers: '/depot-eroeffnen/sparplan-anlegen/top-3-anbieter',
        alternative: '/depot-eroeffnen/sparplan-anlegen/alternative',
        create: '/depot-eroeffnen/sparplan-anlegen/erstellen',
        confirm: '/depot-eroeffnen/sparplan-anlegen/pruefen',
        success: '/depot-eroeffnen/sparplan-anlegen/erfolgreich',
      },
    },
    buyAndSell: '/meindepot/kaufenverkaufen',
    multiOrder: '/meindepot/kaufenverkaufen/multiorder',
    accountoverview: '/meindepot/konto',
    verwaltung: '/verwaltung',
    posteingang: '/posteingang',
    tickets: '/posteingang/tickets',
    watchlist: '/watchlist',
    wincustomer: '/meindepot/kundenwerbenkunden',
    member_home: '/uebersicht',
    multi_order_strategies: '/uebersicht/multi-order-strategien',
    deposit: '/meindepot/einzahlen',
    savings_plans: '/sparplaene',
    add_savings_plan: '/sparplaene/sparplan-einrichten',
    check_savings_plan: '/sparplaene/sparplan-pruefen',
    edit_savings_plan: '/sparplaene/sparplan-editieren',
    crypto: '/krypto',
    portfolioTransfer: '/depotwechsel-starten',
    instrument_detail: '/instrument',
    kryptoOnboarding: '/verwaltung/kryptohandelfreischaltung',
    bezugsrecht: '/bezugsrecht',
    teilrecht: '/teilrecht',
    wahldividende: '/wahldividende',
    stats: '/statistik',
    orders: '/meine-orders',
    lombard: '/depotkredit',
    trading: '/trading',
    etfs: '/etfs',
    stocks: '/aktien',
  },
};
export const famousIndications: FamousIndication[] = [
  {
    name: 'DAX',
    isin: 'DE0008469008',
    instrumentType: InstrumentType.Index,
    isOverviewInstrument: true,
    order: 1,
  },
  {
    name: 'TecDAX',
    isin: 'DE0007203275',
    instrumentType: InstrumentType.Index,
  },
  {
    name: 'MDAX',
    isin: 'DE0008467416',
    instrumentType: InstrumentType.Index,
  },
  {
    name: 'Euro Stoxx',
    isin: 'EU0009658145',
    instrumentType: InstrumentType.Index,
  },
  {
    name: 'Dow Jones',
    isin: 'US2605661048',
    instrumentType: InstrumentType.Index,
    isOverviewInstrument: true,
    order: 2,
  },
  {
    name: 'NASDAQ',
    isin: 'US6311011026',
    instrumentType: InstrumentType.Index,
    isOverviewInstrument: true,
    order: 3,
  },
  {
    name: 'S&P 500',
    isin: 'US78378X1072',
    instrumentType: InstrumentType.Index,
    isOverviewInstrument: true,
    order: 4,
  },
  {
    name: 'EUR/USD',
    isin: 'EU0009652759',
    instrumentType: InstrumentType.Currency,
    isOverviewInstrument: true,
    order: 6,
    priceScale: 4,
  },
  {
    name: 'Bitcoin',
    isin: 'XC000A2YY6Q6',
    instrumentType: InstrumentType.Crypto,
    isOverviewInstrument: true,
    order: 7,
    specialLeverageProduct: {
      name: 'Bitcoin Future',
      isin: 'US12573M4006',
    },
  },
  {
    name: 'Ethereum',
    isin: 'XC000A2YY6X2',
    instrumentType: InstrumentType.Crypto,
  },
  {
    name: 'Gold',
    isin: 'XC0009655157',
    instrumentType: InstrumentType.Commodity,
    isOverviewInstrument: true,
    order: 5,
  },
  {
    name: 'Silber',
    isin: 'XC0009653103',
    instrumentType: InstrumentType.Commodity,
  },
  {
    name: 'Öl (Brent)',
    isin: 'XC0009677409',
    instrumentType: InstrumentType.Commodity,
  },
  {
    name: 'Öl (WTI)',
    isin: 'XC0007924514',
    instrumentType: InstrumentType.Commodity,
  },
];
export const URL_APPSTORE_APPLE = 'https://apps.apple.com/de/app/finanzen-net-zero-broker/id1556711130';
export const URL_APPSTORE_GOOGLE = 'https://play.google.com/store/apps/details?id=de.gratisbroker.android.mobileapp';
export const URL_APPSTORE_APPLE_TAN = 'https://apps.apple.com/de/app/finanzen-net-zero-secure-tan/id1531074456';
export const URL_APPSTORE_GOOGLE_TAN = 'https://play.google.com/store/apps/details?id=de.gratisbroker.android.securetan';
